import selectGamePath from './game-path';
import selectGameKeys from './select-game-keys';
import { selectTotalScoreNumber } from './best-score';

const selectGameSummary = (mentalHorsepower, { summary }) => {
  if (!mentalHorsepower) return null;

  const { games, timesPlayed } = mentalHorsepower;

  const totalPossible = selectTotalScoreNumber(games, 'total');
  const totalScore = selectTotalScoreNumber(games, 'score');

  const maxTimesPlayed = Math.max(2, timesPlayed);
  const maxPossibleScore = Math.max(18, totalPossible);

  return [
    {
      key: 'games',
      value: `${timesPlayed}/${maxTimesPlayed}`,
      descriptor: summary.gamesPlayed,
    },
    {
      key: 'answers',
      value: `${totalScore}/${maxPossibleScore}`,
      descriptor: summary.correctAnswers,
    },
  ];
};

const selectScoreCardMentalHorsepower = (
  { mentalHorsepower } = {},
  { mentalHorsepower: { gameTitle, gameDescription, playNow }, ...restPhrases },
  remainingChallenges,
) => ({
  heroKey: 'mathematical',
  gameTitle,
  gameDescription,
  imageUrl: 'https://images.ctfassets.net/gtqjh9j40j4m/1Q82LxG6HnkSgohCBOSKU9/d2ef919f8a60883959ba34498bc9b08d/brainpower-icon-background.png',
  summary: selectGameSummary(mentalHorsepower, restPhrases),
  nextGamePath: selectGamePath(remainingChallenges, 'mental_horsepower'),
  nextGameLink: playNow,
  ...selectGameKeys({ mentalHorsepower }),
});

export default selectScoreCardMentalHorsepower;
